import { fromJS } from 'immutable';
import { SET_USAGE_CLAIMS } from 'containers/UsageClaimsPage/constants';
import { RESET_STORE } from 'containers/LoginPage/constants';

const initialState: any = fromJS({
  claims: [],
  countClaims: 0,
});

const usageClaimsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_USAGE_CLAIMS:
      return state
        .set('claims', fromJS(action.response.claims))
        .set('countClaims', fromJS(action.response.total));
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default usageClaimsReducer;
